/***
 *
 * Comparison Slider
 *
 * Creates a slider which can seamlessly blend two images in a before/after state
 *
 */

if (!customElements.get('comparison-slider')) {
    customElements.define(
        'comparison-slider',
        class ComparisonSlider extends HTMLElement {
            constructor() {
                super();
                this.slider = this.querySelector('[data-slider]');
                this.divisor = this.querySelector('[data-divisor]');
                if (!this.slider || !this.divisor) return;
                this.slider.addEventListener('input', this.slide.bind(this));
            }

            slide() {
                this.divisor.style.width = this.slider.value + '%';
            }
        }
    );
}
